"use client";

import { ReactNode, useEffect } from "react";

import { useMobileHorizontalScroll } from "@hooks/use-mobile-horizontal-scroll";

interface MobileScrollWrapperProps {
  children: ReactNode;
  containerClassName?: string;
  scrollTrackClassName?: string;
  scrollThumbClassName?: string;
  isLoading?: boolean;
  depKey?: string | number | boolean | null;
}

export function MobileScrollWrapper({
  children,
  containerClassName,
  scrollTrackClassName,
  scrollThumbClassName,
  isLoading,
  depKey,
}: Readonly<MobileScrollWrapperProps>) {
  const { horizontalScrollRef, scrollThumbRef, updateScrollThumb, isScrollable } =
    useMobileHorizontalScroll();

  useEffect(() => {
    if (!isLoading) {
      updateScrollThumb();
    }
  }, [updateScrollThumb, isLoading, depKey]);

  return (
    <>
      <div ref={horizontalScrollRef} className={containerClassName}>
        {children}
      </div>
      {isScrollable && (
        <div className={scrollTrackClassName}>
          <div ref={scrollThumbRef} className={scrollThumbClassName} />
        </div>
      )}
    </>
  );
}
